import { State } from '@progress/kendo-data-query';
import { EncryptStorage } from 'encrypt-storage';

/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
export const environment = {
  production: true,
  // apiUrl: 'https://localhost:44389/api', //local
  // apiUrl: 'https://mdbapiosrtc.amnex.com/api', //live
  // apiUrl: 'https://osrtuat.amnex.com/mdbapi/api', //UAT
  apiUrl: 'https://master.osrtc.org/mdbapi/api', //LIVE
  // OPRSAPIUrl : 'https://oprsapiosrtc.amnex.com/api', //live
  //OPRSAPIUrl : 'https://osrtuat.amnex.com/oprsapi/api', //UAT
  OPRSAPIUrl : 'https://counter.osrtc.org/oprsapi/api', //LIVE
  // recaptcha: {
  // siteKey: '6LdLAg4mAAAAANe4IwF9tsAJC34xZDQ0GWk-SK4B',
  // },
  // recaptcha: {
  //   //   siteKey: '6LcgwhImAAAAAIvu2sk4SOF9fyY52mRHapiD5oYm',
  //   //   } //Local
  // ,

  /*//commneted as of now as not in use
  firebase: {
    apiKey: "AIzaSyCSHIGTsmRlS1KiGeoGpEjQxU_3V68PMCM",
    authDomain: "fcmdemo-4fed5.firebaseapp.com",
    projectId: "fcmdemo-4fed5",
    storageBucket: "fcmdemo-4fed5.appspot.com",
    messagingSenderId: "195985764370",
    appId: "1:195985764370:web:c887590c14e35f6795e8cb",
    measurementId: "G-7PLT8FSHL7"
  }*/
};

export const clientID = 4;

export const SystemURLs: any = {
  MDB_URL:"https://master.osrtc.org/#",
  HRMS_URL:"https://mms.osrtc.org/#/loginsso",
  PNS_URL:"https://pns.osrtc.org/Login/LoginSSO",
  OPRSCOUNTER_URL:"https://counter.osrtc.org/#/auth/login/loginsso",
  AFCSUrl:"https://afcs.osrtc.org/Login/LoginSSO",
  GRMSUrl:"https:///grms.osrtc.org/Login/LoginSSO",
  AVLSUrl:"https://avls.osrtc.org/Login/LoginSSO",
  DMS_URL:"https://dms.osrtc.org/#/loginsso",
  OPRS_REPORT_URL:"https://report.osrtc.org/#/auth/login/loginsso",
  // MDB_URL:"https://osrtclivemdb.amnex.com/#",
  // HRMS_URL:"https://osrtclivehrms.amnex.com/#/loginsso",
  // PNS_URL:"https://osrtclivepns.amnex.com/Login/LoginSSO",
  // OPRSCOUNTER_URL:"https://osrtcliveoprs.amnex.com/counterweb/#/auth/login/loginsso",
  // AFCSUrl:"https://osrtcliveafcs.amnex.com/Login/LoginSSO",
  // GRMSUrl:"https:///osrtclivegrms.amnex.com/Login/LoginSSO",
  // AVLSUrl:"https://osrtcliveavls.amnex.com/Login/LoginSSO",
  // DMS_URL:"https://osrtclivedms.amnex.com/#/loginsso",
  // OPRS_REPORT_URL:"https://osrtcliveoprs.amnex.com/oprsmis/#/auth/login/loginsso",
};

export const PageState: State = {
  skip: 0,
  take: 10
};

export const PageSizes: any = [10, 20, 50, 100, 200, 500];

export const pageSize = 10;

export const AccessRights: Rights = {
  isAdd: true,
  isEdit: true,
  isDelete: true,
  isViewExport:true
};

export interface Rights {
  isViewExport:boolean;
  isAdd: boolean;
  isEdit: boolean;
  isDelete: boolean;
}

/*//commneted as not in use
export const DefaultMapLocation: MapLocation = {
  Latitude: 30.7333,
  Longitude: 76.7794
}*/

// export const HereMapAPIKey = 'ubODHhXnhEWiAVOwjXW9Tiq67A4No3hOAYHvB9wexdk';

/*//commneted as not in use
export interface MapLocation {
  Latitude: number;
  Longitude: number;
}*/

export const ExportExcelLogoCellMerge: string = "A1:A3";

export const encryptStorage = new EncryptStorage('secret-key', {
  prefix: '', 
});


export const OPRSCounterBooking_ID = 2;
export const MDB_ID = 4;
export const PNS_ID = 5;
export const AVLS_ID = 6;
export const DMS_ID = 7;
export const HRMS_ID = 8;
export const AFCS_ID = 9;
export const GRMS_ID = 10;
export const OPRS_REPORTS_ID = 11;

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.

